import React from 'react';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__accent" aria-hidden="true" />

      <div className="footer__inner">
        <span className="footer__copy">© 2026 Scinova Scientifics</span>

        <div className="footer__divider" aria-hidden="true" />

        <p className="footer__powered">
          Powered by{' '}
          <a
            href="https://ciirc.res.in/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer__link"
          >
            CIIRC<sup>&reg;</sup>
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;